import React, { useLayoutEffect, useState } from 'react'

/**
 * triggers re-render on window-size update
 *  @return window size whenever updated
 */
export function useWindowSize(dimension: 'width' | 'height' | 'both' = 'both') {
	const [width, setWidth] = useState(0)
	const [height, setHeight] = useState(0)

	useLayoutEffect(() => {
		function updateSize() {
			if (dimension === 'width' || dimension === 'both') {
				setWidth(window.innerWidth)
			}
			if (dimension === 'height' || dimension === 'both') {
				setHeight(window.innerHeight)
			}
		}
		window.addEventListener('resize', updateSize)
		updateSize()
		return () => window.removeEventListener('resize', updateSize)
	}, [])

	return [width, height]
}
